import { makeAutoObservable, runInAction } from 'mobx'
import * as API from '../../../service/api/AccountManage/AccountApi'
import table from '../../commons/table'
import { IRelateContent } from 'models/ContentManage.model'
import moment from 'moment'

class AccountStore {
  constructor() {
    makeAutoObservable(this)
  }

  setStoreByKey = (key, val) => {
    this[key] = val
  }

  table = new table(API.GET_ACCOUNT_LIST)

  init = (param, pageNo, pageSize) => {
    this.table.init(param)
    this.table.getList(pageNo, pageSize)
  }

  addCount = async (data) => {
    return await API.ADD_ACCOUNT(data)
  }

  delAccount = async (data) => {
    return await API.DEL_ACCOUNT(data)
  }

  getAccountDetail = async (id) => {
    return await API.GET_ACCOUNT_DETAIL(id)
  }

  updateAccount = async (data) => {
    return await API.UPDATE_ACCOUNT(data)
  }

  // 机构下拉框列表
  institutionList = []
  getInstitutionList = async () => {
    let res = await API.GET_INSTITUTION_LIST()
    if (res.code === 0) {
      runInAction(() => {
        this.institutionList = res.data || []
      })
    }
  }

  // 获取机构下门店列表
  storeList = []
  getStoreList = async (orgId) => {
    let res = await API.GET_STORE_LIST_BY_INSTITUTION(orgId)
    if (res.code === 0) {
      runInAction(() => {
        this.storeList = res.data || []
      })
    }
  }

  // 内容下拉框列表
  contentList: any = []
  getContentList = async () => {
    let res = await API.GET_CONTENT_LIST()
    if (res.code === 0) {
      runInAction(() => {
        this.contentList = res.data || []
      })
    }
  }

  findContentById = (contentId) => {
    return this.contentList.find((item) => item.key === contentId)
  }

  // 关联内容
  relateContentList: IRelateContent[] = []
  addRelateContentList = (relateContent: IRelateContent) => {
    this.relateContentList.push(relateContent)
    runInAction(() => {
      this.relateContentList = [...this.relateContentList]
    })
  }

  // 删除关联内容
  delRelateContentList = (ids) => {
    runInAction(() => {
      this.relateContentList = this.relateContentList.filter(
        (item) => !ids.includes(item.contentId)
      )
    })
  }

  // 设置关联内容
  initRelateContentList = (list = []) => {
    const arr = list.map(
      ({
        appBusId,
        name,
        status,
        validStartDate,
        validEndDate,
        pkgVersion
      }) => ({
        contentId: appBusId,
        contentName: name,
        status: status === undefined ? undefined : String(status),
        startTime: validStartDate,
        endTime: validEndDate,
        version: pkgVersion
      })
    )
    runInAction(() => {
      this.relateContentList = [...arr]
    })
  }

  getRelateContentParam = () => {
    console.log('this.relateContentList:', this.relateContentList)
    const result = this.relateContentList.map(
      ({ contentId, startTime, endTime, status }) => {
        return {
          appBusId: contentId,
          validStartDate: startTime
            ? moment(startTime).format('YYYY-MM-DD')
            : undefined,
          validEndDate: endTime
            ? moment(endTime).format('YYYY-MM-DD')
            : undefined,
          status: status === undefined ? undefined : String(status)
        }
      }
    )
    return result
  }
}

export default new AccountStore()
